/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const formatIndent = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 7.2v1.5h16V7.2H4zm8 8.6h8v-1.5h-8v1.5zm-8-3.5l3 3-3 3 1 1 4-4-4-4-1 1z" />
	</SVG>
);

export default formatIndent;
